import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';

const DialogConfirmation = ({ open, handleClose, title, content, handleAgree, closeButtonText, agreeButtonText }) => {
  const component = (
    <Dialog open={open} aria-labelledby={title} aria-describedby={content}>
      <DialogTitle id={title}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id={content}>{content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {closeButtonText && <Button onClick={handleClose}>{closeButtonText || 'TUTUP'}</Button>}
        {agreeButtonText && <Button onClick={handleAgree}>{agreeButtonText || 'OK'}</Button>}
      </DialogActions>
    </Dialog>
  );
  return component;
};

DialogConfirmation.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  handleAgree: PropTypes.func.isRequired,
  closeButtonText: PropTypes.string.isRequired,
  agreeButtonText: PropTypes.string.isRequired,
};

export default DialogConfirmation;
